import { render, staticRenderFns } from "./PackerContainerFileForm.vue?vue&type=template&id=28f7f836"
import script from "./PackerContainerFileForm.vue?vue&type=script&lang=js"
export * from "./PackerContainerFileForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports